module.exports = __webpack_public_path__ + "static/media/ipadmini_light.07aafd62.svg";